import ContactInfo from '../components/Contact/ContactInfo';
import ContactForm from '../components/Contact/ContactForm';

export default function ContactPage({ submitted, setSubmitted, isLoading, setIsLoading }) {
  return (
    <div className="py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row">
          <ContactInfo />
          <div className="md:w-1/2">
            <div className="bg-white rounded-lg shadow-md p-8">
              <ContactForm 
                submitted={submitted} 
                setSubmitted={setSubmitted}
                isLoading={isLoading}
                setIsLoading={setIsLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}